interface ColourPickerProps {
  onTextColourSelect: (value: string) => void;
  onTextColourClear: () => void;
  onHighlightColourSelect: (value: string) => void;
  onHighlightColourClear: () => void;
  onClose: () => void;
}

/**
 * Colours definition for text and highlight
 */
const colors = [
  { name: "Base", value: "#353E47" },
  { name: "White", value: "#FFFFFF" },
  { name: "Pink", value: "#ed7082" },
  { name: "Orange", value: "#f0923c" },
  { name: "Darker Yellow", value: "#f3af43" },
  { name: "Yellow", value: "#f5c242" },
  { name: "Green", value: "#75be65" },
  { name: "Cyan", value: "#57ba8f" },
  { name: "Light Blue", value: "#72afd2" },
  { name: "Dark Blue", value: "#5f95f8" },
  { name: "Purple", value: "#9268f7" },
  { name: "Pink", value: "#c269ca" },
];

const highlightColors = [
  { name: "Pink", value: "#ed7082" },
  { name: "Orange", value: "#f0923c" },
  { name: "Darker Yellow", value: "#f3af43" },
  { name: "Yellow", value: "#f5c242" },
  { name: "Green", value: "#75be65" },
  { name: "Cyan", value: "#57ba8f" },
  { name: "Light Blue", value: "#72afd2" },
  { name: "Dark Blue", value: "#5f95f8" },
  { name: "Purple", value: "#9268f7" },
  { name: "Pink", value: "#c269ca" },
];

const ColourPicker: React.FC<ColourPickerProps> = ({
  onTextColourSelect,
  onTextColourClear,
  onHighlightColourSelect,
  onHighlightColourClear,
  onClose,
}) => {
  return (
    <>
      <div className="fixed inset-0 w-full h-full z-10" onClick={onClose} />
      <div
        className="absolute top-full left-0 bg-neutral-100 border border-neutral-300 rounded-lg shadow-lg p-2 z-10 w-fit inline-flex flex-col gap-3"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Colour selection */}
        <div className="inline-flex flex-col gap-1">
          <p className="text-xs text-neutral-700 select-none">Text colours</p>
          <div className="inline-flex items-start">
            {colors.map((color) => (
              <button
                key={color.value}
                onClick={() => onTextColourSelect(color.value)}
                className="w-4 h-4 rounded border border-neutral-300 hover:scale-110 transition-transform"
                style={{ backgroundColor: color.value }}
                title={color.name}
                type="button"
              />
            ))}
          </div>
          <button
            onClick={onTextColourClear}
            className="px-0.5 top-1 text-xs font-sans text-neutral-700 bg-neutral-100 hover:bg-neutral-200 rounded border border-neutral-300"
            type="button"
          >
            Clear text colour
          </button>
        </div>
        {/* Highlight  */}
        <div className="inline-flex flex-col gap-1">
          <p className="text-xs text-neutral-700 select-none">
            Highlight colours
          </p>
          <div className="inline-flex items-start">
            {highlightColors.map((highlight) => (
              <button
                key={highlight.value}
                onClick={() => onHighlightColourSelect(highlight.value)}
                className="w-4 h-4 rounded border border-neutral-300 hover:scale-110 transition-transform"
                style={{ backgroundColor: highlight.value }}
                title={highlight.name}
                type="button"
              />
            ))}
          </div>
          <button
            onClick={onHighlightColourClear}
            className="px-0.5 top-1 text-xs font-sans text-neutral-700 bg-neutral-100 hover:bg-neutral-200 rounded border border-neutral-300"
            type="button"
          >
            Clear highlight
          </button>
        </div>
      </div>
    </>
  );
};

export default ColourPicker;
